import { IImportHandler } from '../import-handler.interface';
import { JsonFileDataParser, WorkspaceIdGeneratorService, WorkspaceRepository } from '@database/central';
import { ErrorCodes, FileModel } from '@shared';
import { getUnixTime } from 'date-fns';
import { LoggingService } from '@shared/logging';
import { ICleanupImportHandler } from '../cleanup-import-handler.interface';

export class CentralDatabaseDataImporterHandler implements ICleanupImportHandler {
	private next: IImportHandler;

	public constructor(
		private jsonFileDataParser: JsonFileDataParser,
		private workspaceRepository: WorkspaceRepository,
		private workspaceGeneratorService: WorkspaceIdGeneratorService,
		private loggingService: LoggingService,
		private importedFromFile: boolean
	) {}

	public async cleanup(model: FileModel): Promise<void> {
		await this.workspaceRepository.remove(model.workFileId);
	}

	public setNext(nextHandler: IImportHandler) {
		this.next = nextHandler;
	}

	public async handle(model: FileModel) {
		try {
			const projects = this.jsonFileDataParser.extractProjectsList(model.FusionReferenceTables);
			model.workFileId = this.workspaceGeneratorService.generateRandomId();

			await this.workspaceRepository.insert({
				workFileId: model.workFileId,
				workspaceName: model.FileDisplayName,
				projects,
				fusionEntities: model.FusionEntities,
				importedUnix: getUnixTime(new Date()),
				fussionConfigHeaders: model.FusionConfigHeader,
				fusionUsers: model.FusionUsers,
				archived: false,
				pendingDelete: false,
				importedFromFile: this.importedFromFile,
				apiConnectionId: model.apiConnectionId
			});
		} catch (error) {
			this.loggingService.error(ErrorCodes.CentralDatabaseDataImporterHandler, error);
			await this.cleanup(model);
			throw new Error('Could not insert workspace into central database');
		}

		if (this.next) {
			await this.next.handle(model);
		}
	}
}
